import styled from 'styled-components';

export const Container = styled.div`
  max-width: 390px;
  p {
    font-size: 16px;
    line-height: 24px;
    color: #4a4a4a;
  }
`;
export const ContentRight = styled.div`
  flex: 1;
  margin-top: 20px;
  h4 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 900;
    color: #333333;
    margin-bottom: 12px;
  }
  p {
    font-size: 16px;
    line-height: 24px;
    color: #4a4a4a;
    span {
      font-weight: 900;
    }
  }
  span {
    direction: ltr !important;
  }
`;
